<template>
  <div>
    <div class="wraper" v-if="!isProjectLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader></ProjectHeader>
        <div style="padding: 10px 20px;">
          <h4>
            1. Соответствуют ли технологии, применяемые в рамках проекта,
            правилам НДТ?
          </h4>
          <div class="row" style="margin-bottom: 20px">
            <div style="padding-left: 30px;" class="col-md-4">
              <label class="radio-inline" style="text-align: right;width: 30px">
                <input
                  style="margin-left: -25px;"
                  type="radio"
                  name="tech_ag"
                  value="1"
                  :disabled="!isEditPage"
                  :checked="dopInfo.UF_TECHNOLOY_NDT_ID.length"
                  @click="changeTechChoice(1)"
                />
                <span>да</span>
              </label>
              <label class="radio-inline" style="width: 20px">
                <input
                  type="radio"
                  style="float: left;display: block;"
                  name="tech_ag"
                  value="2"
                  :disabled="!isEditPage"
                  @click="resetTechChoice(false)"
                  :checked="dopInfo.UF_TECHNOLOY_NDT_ID.length === 0"
                />
                <span>нет</span>
              </label>
            </div>
          </div>
          <div class="row" v-if="showTechChoice">
            <div class=" col-md-4">
              <div
                class="modal-content"
                style="margin-top:0; margin-bottom: 20px"
              >
                <div class="modal-body">
                  <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    @click="showTechChoice = false"
                    :disabled="!isEditPage"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <br />
                  <div class="form-group">
                    <label>НДТ</label>
                    <Multiselect
                      label="NAME"
                      class="i-main-style-rp"
                      style="
                      width: 98%;
                      min-height: 70px;
                      "
                      :limit="3"
                      :limitText="filterItemText"
                      track-by="ID"
                      v-model="UF_TECHNOLOY_NDT_ID"
                      :options="directory.sp_ndt"
                      :multiple="true"
                      placeholder=""
                    />

                    <!-- <select
                      class="form-control"
                      v-model="UF_TECHNOLOY_NDT_ID"
                      multiple
                      :disabled="!isEditPage"
                    >
                      <option
                        v-for="item in directory.sp_ndt"
                        v-bind:key="item.ID"
                        v-bind:value="item.ID"
                        v-text="item.NAME"
                      ></option>
                    </select> -->
                  </div>
                  <div class="form-group">
                    <label>Опишите технологию</label>
                    <textarea
                      class="form-control"
                      maxlength="150"
                      v-model="UF_TECHNOLOY_NDT_TXT"
                    >
                    </textarea>
                  </div>
                  <button
                    type="button"
                    @click="saveTechChoice()"
                    class="btn btn-default"
                  >
                    Сохранить
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row"
            v-if="dopInfo.UF_TECHNOLOY_NDT_ID.length > 0 && !showTechChoice"
          >
            <div class=" col-md-4">
              <div
                class="modal-content"
                style="margin-top:00px; margin-bottom: 20px"
              >
                <div class="modal-body">
                  <div class="form-group">
                    <label>Справочник НДТ</label><br />
                    <div v-for="id in dopInfo.UF_TECHNOLOY_NDT_ID">
                      {{ id.NAME }}
                      <!-- {{ getNdt(id).NAME }} -->
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Описание технологии</label><br />
                    {{ dopInfo.UF_TECHNOLOY_NDT_TXT }}
                  </div>
                  <button
                    type="button"
                    v-if="isEditPage"
                    :disabled="!isEditPage"
                    @click="changeTechChoice()"
                    class="btn btn-default"
                  >
                    Изменить
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h4>2. Импортозамещение</h4>
          <div class="row">
            <div class=" col-md-6">
              <div class="form-inline">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-addon">
                      Доля импортной продукции на рынке в момент запуска
                      проекта, %
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      v-model="dopInfo.UF_IMPORT_DOL_BEFORE"
                      :disabled="!isEditPage"
                      v-on:keypress="isNumber($event)"
                      v-on:keyup="
                        dopInfo.UF_IMPORT_DOL_BEFORE = checkValue(
                          dopInfo.UF_IMPORT_DOL_BEFORE
                        )
                      "
                    />
                  </div>
                </div>
              </div>
              <br />
              <div class="form-inline">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-addon">
                      Планируемая доля импорта продукции после реализации, %
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      v-model="dopInfo.UF_IMPORT_DOL_AFTER"
                      :disabled="!isEditPage"
                      v-on:keypress="isNumber($event)"
                      v-on:keyup="
                        dopInfo.UF_IMPORT_DOL_AFTER = checkValue(
                          dopInfo.UF_IMPORT_DOL_AFTER
                        )
                      "
                    />
                  </div>
                </div>
              </div>

              <div class="form-inline">
                <div class="form-group">
                  <div class="input-group">
                    <br />
                    <div class="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          :disabled="!isEditPage"
                          v-model="dopInfo.UF_IMPORT_IS_POTENCIAL_NTE"
                        />
                        Потенциал, определенный научно-технической экспертизой
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <h4>3. Тип проекта</h4>
          <div class="row">
            <div class=" col-md-4">
              <div class="form-group">
                <select
                  class="form-control"
                  v-model="dopInfo.UF_TYPE_PROJECT"
                  :disabled="!isEditPage"
                >
                  <option></option>
                  <option
                    v-for="item in directory.type_project"
                    v-bind:key="item.ID"
                    v-bind:value="item.ID"
                    v-text="item.NAME"
                  ></option>
                </select>
              </div>
            </div>
          </div>
          <template v-if="showPunctStavka">
            <h4>
              4. Проект проходит по ставке 1% по условию экспорта продукции
            </h4>
            <div class="row">
              <div class=" col-md-4">
                <div
                  class="form-group"
                  v-for="item in directory.export_endition"
                >
                  <div class="checkbox">
                    <label>
                      <input
                        type="checkbox"
                        :disabled="!isEditPage"
                        :value="item.ID"
                        v-model="dopInfo.UF_EXPORT_ENDITION"
                      />
                      {{ item.NAME }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <h4>
              5. Субсидия в рамках национального проекта "Международная
              кооперация и экспорт"
            </h4>
            <div class="row">
              <div class=" col-md-4">
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input
                        type="checkbox"
                        :disabled="!isEditPage"
                        v-model="dopInfo.UF_IS_EXP_KOOPERACIY"
                      />
                      Да
                    </label>
                  </div>
                </div>
                Дата обновления: {{ dopInfo.UF_IS_EXP_KPR_DATE }}
              </div>
            </div>
          </template>
          <h4>
            4. Риск-класс
          </h4>
          <div class="row">
            <div class=" col-md-4">
              <div class="form-group">
                <select
                  v-model="dopInfo.UF_EXPERTISE_RISK_CLASS_ID"
                  :disabled="!isEditPage"
                  class="form-control"
                >
                  <option
                    v-for="expertiseRickClass in dopInfo.RISK_CLASS_SP"
                    :value="expertiseRickClass.ID"
                    :key="expertiseRickClass.ID"
                    >{{ expertiseRickClass.UF_NAME }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <h4>5. Информация для повестки</h4>

          <div class="row">
            <div class="col-md-1">
              <h5><b>Оборудование</b></h5>
            </div>
            <div class=" col-md-3">
              <div class="form-group">
                <Multiselect
                  label="NAME"
                  class="mult-filter-select-stl stl-border-color--blue"
                  :limit="100"
                  :limitText="filterItemText"
                  track-by="ID"
                  v-model="dopInfo.UF_INFORMATION_EQUIPMENT_COUNTY_ID"
                  :options="directory.country_rus_first"
                  :multiple="true"
                  placeholder=""
                  :disabled="!isEditPage"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-1">
              <h5><b>Пуско-наладка</b></h5>
            </div>
            <div class=" col-md-3">
              <div class="form-group">
                <Multiselect
                  label="NAME"
                  class="mult-filter-select-stl stl-border-color--blue"
                  :limit="100"
                  :limitText="filterItemText"
                  track-by="ID"
                  v-model="dopInfo.UF_INFORMATION_START_COUNTY_ID"
                  :options="directory.country_rus_first"
                  :multiple="true"
                  placeholder=""
                  :disabled="!isEditPage"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-1">
              <h5><b>Сырье</b></h5>
            </div>
            <div class=" col-md-3">
              <div class="form-group">
                <Multiselect
                  label="NAME"
                  class="mult-filter-select-stl stl-border-color--blue"
                  :limit="100"
                  :limitText="filterItemText"
                  track-by="ID"
                  v-model="dopInfo.UF_INFORMATION_MATERIAL_COUNTY_ID"
                  :options="directory.country_rus_first"
                  :multiple="true"
                  placeholder=""
                  :disabled="!isEditPage"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-1">
              <h5><b>Экспорт</b></h5>
            </div>
            <div class=" col-md-3">
              <div class="form-group">
                <select
                  class="form-control"
                  style="width: auto;"
                  v-model="dopInfo.UF_INFORMATION_IS_EXPORT"
                  :disabled="!isEditPage"
                >
                  <option v-bind:key="1" v-bind:value="1">Да</option>
                  <option v-bind:key="0" v-bind:value="0">Нет</option>
                </select>
              </div>
            </div>
          </div>

          <h4>
            6. Соответствие проекта ПП (1388, 189)
          </h4>
          <div class="row">
            <div class=" col-md-4">
              <div class="form-group" v-for="item in validPP()">
                <div class="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      :value="item.ID"
                      :disabled="!isEditPage"
                      v-model="dopInfo.UF_IS_VALID_PP"
                    />
                    {{ item.NAME }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <template v-if="dopInfo.meta.IS_NATIONAL_PROJECTS_DOP_INFO_VIEW">
            <h4>7. Соответствует Национальным проектам</h4>
            <div class="row">
              <div class=" col-md-4">
                <div
                  class="form-group"
                  v-bind:class="{
                    'has-error': checkContactErrorField(
                      'UF_IS_NATIONAL_PROJECTS'
                    )
                  }"
                >
                  <select
                    class="form-control"
                    style="width: auto;"
                    v-model="dopInfo.UF_IS_NATIONAL_PROJECTS"
                    :disabled="!isEditPage"
                    @change="removeError('UF_IS_NATIONAL_PROJECTS')"
                  >
                    <option></option>
                    <option v-bind:key="1" v-bind:value="1">Да</option>
                    <option v-bind:key="0" v-bind:value="0">Нет</option>
                  </select>
                  <div class="error-text">
                    {{ checkContactErrorField("UF_IS_NATIONAL_PROJECTS") }}
                  </div>
                </div>
              </div>
            </div>
            <template v-if="dopInfo.UF_IS_NATIONAL_PROJECTS">
              <h5><b>Соответствие Национальным проектам</b></h5>
              <div class="row">
                <div class=" col-md-6">
                  <div
                    class="form-group"
                    v-bind:class="{
                      'has-error': checkContactErrorField(
                        'UF_NATIONAL_PROJECTS_LIST_ID'
                      )
                    }"
                  >
                    <Multiselect
                      label="NAME"
                      class="mult-filter-select-stl stl-border-color--blue"
                      :limit="100"
                      :limitText="filterItemText"
                      track-by="ID"
                      v-model="dopInfo.UF_NATIONAL_PROJECTS_LIST_ID"
                      :options="directory.sp_list_national_projects"
                      :multiple="true"
                      placeholder=""
                      :disabled="!isEditPage"
                      @input="removeError('UF_NATIONAL_PROJECTS_LIST_ID')"
                    />
                    <div class="error-text">
                      {{
                        checkContactErrorField("UF_NATIONAL_PROJECTS_LIST_ID")
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>

          <h4>
            <span v-if="dopInfo.meta.IS_NATIONAL_PROJECTS_DOP_INFO_VIEW">8</span
            ><span v-else>7</span>. Планируемый год подписания договора
          </h4>
          <div class="row">
            <div class=" col-md-3">
              <div class="form-group">
                <select
                  class="form-control"
                  style="width: 150px;"
                  v-model="dopInfo.UF_LOAN_UPDATE_PLAN_YEAR"
                >
                  <option
                    v-for="item in dopInfo.meta.YEARS"
                    v-bind:key="item"
                    v-bind:value="item"
                    v-text="item"
                  ></option>
                </select>
              </div>
            </div>
          </div>
          <br />

          <div class="row">
            <div class="col-md-4">
              <button
                type="button"
                @click="saveInfo()"
                class="btn btn-default"
                v-if="isEditPage"
              >
                Сохранить
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <project-menu></project-menu>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { FETCH_PROJECT, FETCH_DIRECTORY } from "../../store/actions.type";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import { ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";
import ProjectMenu from "@/components/project/partial/ProjectMenu";
import Multiselect from "vue-multiselect";

Vue.filter("fileName", function(value) {
  let l = value.split("/");

  return l[l.length - 1];
});

export default {
  name: "AddInfo",
  title: "Дополнительная информация",
  watch: {},
  computed: {
    ...mapGetters([
      "project",
      "isLoading",
      "directory",
      "currentUser",
      "notifications"
    ])
  },
  data() {
    return {
      showTechChoice: false,
      UF_TECHNOLOY_NDT_ID: [],
      UF_TECHNOLOY_NDT_TXT: "",
      needTech: false,
      showPunctStavka: false,
      isEditPage: false,
      dopInfo: {
        ID: 0,
        UF_PROJECT_ID: 0,
        UF_TECHNOLOY_NDT_ID: [],
        UF_TECHNOLOY_NDT_TXT: "",
        UF_IMPORT_DOL_BEFORE: 0,
        UF_IMPORT_DOL_AFTER: 0,
        UF_TYPE_PROJECT: 0,
        UF_EXPORT_ENDITION: [],
        UF_IS_VALID_PP: [],
        UF_IS_EXP_KOOPERACIY: 0,
        UF_IS_EXP_KPR_DATE: "",
        UF_LOAN_UPDATE_PLAN_YEAR: 0
      },
      ru: ru,
      error: []
    };
  },
  components: {
    ProjectMenu,
    ProjectHeader,
    Datepicker,
    Multiselect
  },
  methods: {
    async fetchProject() {
      await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);

      ProjectsService.getDopInfoDataProject(this.project.ID).then(
        ({ data }) => {
          if (!data.length && data.ID < 1) {
            return;
          }
          if (data.UF_TECHNOLOY_NDT_ID.length) {
            this.needTech = true;
          }
          this.dopInfo = data;
        },
        this
      );
    },
    filterItemText(count) {
      console.log(count);
      return ``;
    },

    changeTechChoice(n) {
      this.needTech = n;
      this.UF_TECHNOLOY_NDT_ID = this.dopInfo.UF_TECHNOLOY_NDT_ID;
      this.UF_TECHNOLOY_NDT_TXT = this.dopInfo.UF_TECHNOLOY_NDT_TXT;
      this.showTechChoice = true;
    },
    saveTechChoice() {
      if (!this.UF_TECHNOLOY_NDT_ID) {
        this.$toasted.show("Необходимо выбрать значение из справочника НДТ!", {
          theme: "red",
          position: "bottom-right",
          duration: 3500
        });
        return;
      }
      this.dopInfo.UF_TECHNOLOY_NDT_ID = this.UF_TECHNOLOY_NDT_ID;
      this.dopInfo.UF_TECHNOLOY_NDT_TXT = this.UF_TECHNOLOY_NDT_TXT;
      this.showTechChoice = false;
    },
    resetTechChoice() {
      this.dopInfo.UF_TECHNOLOY_NDT_ID = [];
      this.dopInfo.UF_TECHNOLOY_NDT_TXT = "";
      this.showTechChoice = false;
      this.needTech = false;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 46) {
        evt.preventDefault();
        return false;
      }

      console.log(charCode);
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    checkValue: function(val) {
      if (val > 100) {
        val = 100;
      }
      return val;
    },
    getStatus: function(id) {
      let t = this.directory.status.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    },
    getNdt: function(id) {
      let t = this.directory.sp_ndt.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    },
    saveInfo() {
      let isError = false;
      this.error = [];
      if (!this.dopInfo.UF_TECHNOLOY_NDT_ID && this.needTech) {
        isError = true;
        this.$toasted.show("Необходимо выбрать значение из справочника НДТ!", {
          theme: "red",
          position: "bottom-right",
          duration: 3500
        });
      }

      ProjectsService.editDopInfoDataProject(
        this.$route.params.id,
        this.dopInfo
      ).then(data => {
        if (data.data.error) {
          isError = true;
          this.error = data.data.errorArr;
          console.log(this.error);
          data.data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }

        let textSave = isError
          ? "Данные сохранены, но форма содержит ошибки"
          : "Данные сохранены";
        let colorSave = isError ? "red" : "green";
        this.$toasted.show(textSave, {
          theme: colorSave,
          position: "bottom-right",
          duration: 3000
        });

        ProjectsService.getDopInfoDataProject(this.project.ID).then(
          ({ data }) => {
            if (!data.length) {
              return;
            }
            this.dopInfo = data;
          },
          this
        );
      }, this);
    },
    checkContactErrorField(field) {
      let t = this.error.filter(c => c.FIELD === field);
      if (t.length > 0) {
        return t[0].TEXT;
      }
      return "";
    },
    removeError(field) {
      this.error.forEach(function(c, k) {
        if (c.FIELD === field) {
          this.error.splice(k, 1);
        }
      }, this);
    },
    inArray(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    validPP() {
      let returnList = [];
      this.directory.sp_is_valid_pp.forEach(function(el) {
        if (el.ONLY_SUPPORT_PROG_LIST.length) {
          if (
            this.inArray(
              this.project.UF_SUPPORT_PROG_ID,
              el.ONLY_SUPPORT_PROG_LIST
            )
          ) {
            returnList.push(el);
          }
        } else {
          returnList.push(el);
        }
      }, this);

      return returnList;
    }
  },

  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["status"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["type_present"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_ndt"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["type_project"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["export_endition"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_is_valid_pp"])
      .then(() => {}, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["country_rus_first"])
      .then(() => {}, this);

    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]).then(() => {
      this.fetchProject();
    }, this);

    await this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_list_national_projects"])
      .then(() => {}, this);

    if (
      this.currentUser.ACTIVE_ROLE_CODE === "manager3" ||
      this.currentUser.ACTIVE_ROLE_CODE === "admin" ||
      this.currentUser.ACTIVE_ROLE_CODE === "manager2"
    ) {
      this.isEditPage = true;
    }
  }
};
</script>

<style scoped></style>
